<ngx-loading-bar [color]="'purple'"></ngx-loading-bar>

<div>

    <app-top-bar></app-top-bar>

    <div class="page-body-wrapper">

        <app-right-sidebar></app-right-sidebar>
        
        <app-sidemenus></app-sidemenus>

        <div class="container-scroller" style="width: 100%; background: #F5F7FF;">
            <router-outlet></router-outlet>
        </div>
        
    </div>
</div>

